<mat-icon
  *ngIf="extUserRole?.oUserWrapper?.isLoading === true; else notLoading"
  class="spinner"
>
  donut_large
</mat-icon>
<ng-template #notLoading>
  {{ text }}
</ng-template>
